import {
    Component,
    Input,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from "@angular/forms";
import { FieldsetToggleComponent } from "@components/fieldset-toggle/fieldset-toggle.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { chain } from "lodash";
import { Observable, of } from "rxjs";
import { ProduktionsstatusPipe } from "~app/common/pipes/produktionsstatus.pipe";
import { SimpleSelectionItem } from "~app/common/components/selector/simple-selection-item";
import { Produktionsstatus } from "~app/common/models/constants";
import { ITplArbetsorder } from "../../../models/dtos";
import { FilterBaseComponent } from "../filter-base-component";
import { TplFilterContext } from "../tpl-filter-context";
import { ITplArbetsorderFilter } from "../tpl-filter.models";

@Component({
    selector: "rask-tpl-produktionsstatus-filter",
    templateUrl: "./tpl-produktionsstatus-filter.component.html",
    styleUrls: ["./tpl-produktionsstatus-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FieldsetToggleComponent,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectorComponent
    ]
})

export class TplProduktionsstatusFilterComponent extends FilterBaseComponent implements OnInit, ITplArbetsorderFilter {

    @Input() dataSource: ITplArbetsorder[];

    options: Observable<SimpleSelectionItem[]>;

    private readonly produktionsstatusPipe = inject(ProduktionsstatusPipe);

    constructor() {
        super("produktionsstatus");
    }

    ngOnInit(): void {
        this.onFormInit(new UntypedFormControl([]));
        this.initOptions();
    }

    match(item: ITplArbetsorder): boolean {
        return this.value().indexOf(item.produktionsstatus) > -1;
    }

    value(): string[] {
        return this.control.value;
    }

    isActive(): boolean {
        return this.value()?.length > 0;
    }

    onFilterInit(state: any): void {
        state = state ?? [];
        this.control.setValue(state);
    }

    protected onAddFilterToContext(filterContext: TplFilterContext) {
        this.filterContext.addArbetsorderFilter(this.name, this);
    }

    private initOptions(): void {
        const order = [
            Produktionsstatus.ProduktionEjPaborjad,
            Produktionsstatus.ProduktionPagar,
            Produktionsstatus.ProduktionAvslutad,
            Produktionsstatus.Slutrapporterad,
            Produktionsstatus.ProduktionGodkand,
            Produktionsstatus.Makulerad
        ];

        const options = chain(this.dataSource)
            .map(x => x.produktionsstatus)
            .uniq()
            .orderBy(x => order.indexOf(x))
            .value();

        const currentValue = this.value();
        const valid = currentValue.filter(x => options.some(x1 => x1 === x));
        this.onFilterInit(valid);

        this.options = of(options.map(x => ({
            text: this.produktionsstatusPipe.transform(x, true),
            value: x
        })));
    }

}
